import { Injectable, inject } from "@angular/core";
import { MODULES } from "src/app/core/modules";
import { ConfigurationService } from "src/app/services/configuration.service";
import { ModuleService } from "src/app/services/feature-access-control/module.service";
import { dateUtil } from "src/app/support/date-util";

export enum FEATURES {
  WAREHOUSE = "warehouse",
  FATTURAZIONE_ELETTRONICA = "fatturazione-elettronica",
  TESSERA_SANITARIA = "tessera-sanitaria",
  FLOWBOARD = "flowboard",
  CUSTOMER_SURVEY = "customer-survey",
  MARKETING = "marketing",
  ROCKET_NOTICE_REPORTS_NO_AUTOSAVE = "rocket-notice-reports-no-autosave"
}

@Injectable()
export class FeatureService {
  readonly #moduleService = inject(ModuleService);
  readonly #configurationService = inject(ConfigurationService);

  #map: Partial<Record<FEATURES, { expiresOn: string }>> = {
    [FEATURES.ROCKET_NOTICE_REPORTS_NO_AUTOSAVE]: {
      expiresOn: dateUtil("2025-12-25", "YYYY-MM-DD").toISOString()
    }
  };

  isEnabled(feature: FEATURES): boolean {
    switch (feature) {
      case FEATURES.WAREHOUSE: {
        return (
          this.#moduleService.canBeActivatedSync(MODULES.WAREHOUSE) &&
          this.#configurationService.warehouse().enabled
        );
      }
      case FEATURES.FATTURAZIONE_ELETTRONICA: {
        return this.#moduleService.canBeActivatedSync(
          MODULES.FATTURAZIONE_ELETTRONICA
        );
      }
      case FEATURES.TESSERA_SANITARIA: {
        return this.#moduleService.canBeActivatedSync(
          MODULES.TESSERA_SANITARIA
        );
      }
      case FEATURES.FLOWBOARD: {
        return this.#moduleService.canBeActivatedSync(MODULES.FLOWBOARD);
      }
      case FEATURES.CUSTOMER_SURVEY: {
        return (
          this.#moduleService.canBeActivatedSync(MODULES.CUSTOMER_SURVEY) &&
          !!this.#configurationService.healthcare().survey?.enabled
        );
      }
      case FEATURES.MARKETING: {
        return this.#moduleService.canBeActivatedSync(MODULES.MARKETING);
      }
      case FEATURES.ROCKET_NOTICE_REPORTS_NO_AUTOSAVE: {
        return dateUtil(
          this.#map[FEATURES.ROCKET_NOTICE_REPORTS_NO_AUTOSAVE]?.expiresOn
        ).isAfter(dateUtil());
      }
    }
  }

  canBeActivated(feature: FEATURES): boolean {
    switch (feature) {
      case FEATURES.CUSTOMER_SURVEY: {
        return this.#moduleService.canBeActivatedSync(MODULES.CUSTOMER_SURVEY);
      }
      case FEATURES.WAREHOUSE: {
        return this.#moduleService.canBeActivatedSync(MODULES.WAREHOUSE);
      }
      default: {
        return false;
      }
    }
  }
}
